import {IStickersShowState} from "./reducer";

export const stickerShowStateSelector = (state: any): IStickersShowState => {
    return state.stickers.showLlama;
}

export const stickerShowCongratulationSelector = (state: any): boolean => {
    return stickerShowStateSelector(state).showCongratulation
}

export const isMemorialType = (state: any): boolean => {
    // The CURRENT sticker decides the theme. This used to read ids[0] - the
    // first sticker ever loaded in the session - so one memorial visit
    // painted every later greeting sticker memorial.
    const stickers = state.stickers.entities.stickers;
    const id = stickers.currentId || stickers.ids[0];
    return stickers.byId[id]?.type === 'MEMORIAL';
};